import { useEffect, useRef, useState } from 'react'
import { isBrowser } from '@utils'

export default function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false)
  const observerRef = useRef(null)
  const observedNodeRef = useRef(null)
  const canObserve = isBrowser() && typeof window !== 'undefined' && Boolean(window.IntersectionObserver)

  useEffect(() => {
    if (!canObserve) return undefined
    if (!observerRef.current) {
      observerRef.current = new window.IntersectionObserver(([entry]) => {
        setIntersecting(entry.isIntersecting)
      })
    }
    const node = ref?.current || null
    const previousNode = observedNodeRef.current

    if (previousNode && previousNode !== node) {
      observerRef.current.unobserve(previousNode)
      observedNodeRef.current = null
    }

    if (node && previousNode !== node) {
      observerRef.current.observe(node)
      observedNodeRef.current = node
    }
    return undefined
  })

  useEffect(() => () => {
    observerRef.current?.disconnect()
    observerRef.current = null
    observedNodeRef.current = null
  }, [])

  return canObserve ? isIntersecting : false
}
